exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".address-bar-menu{padding:.625em .875em;cursor:pointer}.address-bar-menu:hover{opacity:.7}.address-bar-menu svg{height:1.5em;width:1.5em}", "", {"version":3,"sources":["/app/src/components/Elements/MenuToggle/styles/MenuToggle.css"],"names":[],"mappings":"AAAA,kBACE,sBAAyB,AACzB,cAAgB,CACjB,AAED,wBACE,UAAY,CACb,AAED,sBACE,aAAc,AACd,WAAa,CAEd","file":"MenuToggle.css","sourcesContent":[".address-bar-menu {\n  padding: 0.625em 0.875em;\n  cursor: pointer;\n}\n\n.address-bar-menu:hover {\n  opacity: 0.7\n}\n\n.address-bar-menu svg {\n  height: 1.5em;\n  width: 1.5em;\n  /* opacity: 0.7; */\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Elements/MenuToggle/styles/MenuToggle.css
// module id = 1452
// module chunks = 0